import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { useRequiredContext } from "@redotech/react-util/context";
import CodeFilledIcon from "@redotech/redo-icons/code-02_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { useMatch } from "react-router-dom";

export const DevItems = memo(function DevItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const user = useContext(UserContext);
  const isRedoUser = isRedoEmailAddress(user?.email);

  const devBaseUrl = `${routes.supportV2BaseUrl}/dev`;
  const anyChildSelected = useMatch(`${devBaseUrl}/*`);

  // Only show dev navigation for Redo users
  if (!isRedoUser) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: devBaseUrl }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={CodeFilledIcon}
      friendlyName="Dev"
      id="dev"
      UnfilledIcon={CodeFilledIcon}
    >
      <DevClientSideToolsItem />
      <DevConversationInsightsItem />
      <DevFaqEditorTestingItem />
      <DevStreamTesterItem />
      <DevVoiceV2Item />
    </RedoSecondaryNavItem>
  );
});

const DevClientSideToolsItem = memo(function DevClientSideToolsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: `${routes.supportV2BaseUrl}/dev/client-side-tools`,
      }}
      friendlyName="Client-Side Tools"
      id="dev-client-side-tools"
    />
  );
});

const DevConversationInsightsItem = memo(
  function DevConversationInsightsItem() {
    const routes = useRequiredContext(MerchantRoutesContext);

    return (
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: `${routes.supportV2BaseUrl}/dev/conversation-insights`,
        }}
        friendlyName="Conversation Insights"
        id="dev-conversation-insights"
      />
    );
  },
);

const DevFaqEditorTestingItem = memo(function DevFaqEditorTestingItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: `${routes.supportV2BaseUrl}/dev/editor-testing`,
      }}
      friendlyName="Faq Editor Testing"
      id="dev-editor-testing"
    />
  );
});

const DevStreamTesterItem = memo(function DevStreamTesterItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: `${routes.supportV2BaseUrl}/dev/stream-tester`,
      }}
      friendlyName="Stream Tester"
      id="dev-stream-tester"
    />
  );
});

const DevVoiceV2Item = memo(function DevVoiceV2Item() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: `${routes.supportV2BaseUrl}/dev/voice-v2` }}
      friendlyName="Voice v2"
      id="dev-voice-v2"
    />
  );
});
